<template>
  <div class="ti d-flex">
    <!--    <div class="d-flex-left">-->

    <!--    </div>-->
    <div class="d-flex-right">
      <div class="header">
        <div style="margin: 5px 0">
          <div>
            <SelectCdjProjectHeader @onHeader="onHeader">
              <el-select placeholder="账龄类型" clearable v-model="reginWhere.age" size="mini">
<!--                <el-option :value="1" label="当期"></el-option>-->
<!--                <el-option :value="2" label="纯上一年"></el-option>-->
                <el-option :value="3" label="1年以上2年以内"></el-option>
                <el-option :value="4" label="2年以上"></el-option>
              </el-select>
              <el-input
                style="width: 240px"
                placeholder="请输入房产/管家名称/业主名称"
                v-model="where.text"
                clearable size="mini">
              </el-input>
              <el-date-picker
                style="width: 150px"
                v-model="where.start_time"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <el-date-picker
                style="width: 150px"
                v-model="where.end_time"
                size="mini"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <el-select v-model="where.time_field" placeholder="选择筛选的时间类型" size="mini">
                <el-option v-for="(item,index) in time_field_list" :key="index" :value="item.value" :label="item.name"></el-option>
              </el-select>
            </SelectCdjProjectHeader>


          </div>
        </div>
      </div>

      <el-tabs type="border-card" v-model="card_index">
        <el-tab-pane label="催费跟进" name="LitigationLayout">
<!--          <LegalHousePlanUnit v-if="card_index==='LegalHousePlanUnit'" :urge_type="2" @exportExcelNote="exportExcelNote" />-->
          <LitigationLayout v-if="card_index==='LitigationLayout'" />
        </el-tab-pane>
          <el-tab-pane label="资料管理" name="CaseDocumentsManager">
            <CaseDocumentsManager v-if="card_index==='CaseDocumentsManager'" case-type="case" />
          </el-tab-pane>
        <el-tab-pane label="案件管理" name="LitigationCaseLayout">
          <LitigationCaseLayout v-if="card_index==='LitigationCaseLayout'" />
        </el-tab-pane>
        <el-tab-pane label="诉讼记录" name="list">
          <LitigationListLayout v-if="card_index==='list'&&is_loading" />
        </el-tab-pane>
        <el-tab-pane label="项目自诉状态统计表" name="RecordFilingStatusStatisticsTable">
          <RecordFilingStatusStatisticsTable v-if="card_index==='RecordFilingStatusStatisticsTable'" type="1" />
        </el-tab-pane>
<!--        <el-tab-pane label="法院管理" name="court">-->
<!--          <CourtList v-if="card_index==='court'" />-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="近12月统计" name="12month">-->
<!--          <LitigationStatisticsMonth v-if="card_index==='12month'" />-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="近30日统计" name="30day">-->
<!--          <LitigationStatisticsDay v-if="card_index==='30day'" />-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="当月账龄" name="AgingType">-->
<!--          <AgingType v-if="card_index==='AgingType'" types="2" />-->
<!--        </el-tab-pane>-->
<!--        <el-tab-pane label="立案统计" name="bh">-->
<!--          -->
<!--        </el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import LitigationListLayout from "./components/litigation/LitigationListLayout";
import LitigationStatisticsDay from "./components/litigation/LitigationStatisticsDay";
import LitigationStatisticsMonth from "./components/litigation/LitigationStatisticsMonth";
import AgingType from "./components/common/AgingType";
import RecordFilingStatusStatisticsTable from "./components/report_forms/RecordFilingStatusStatisticsTable";
import LegalHousePlanUnit from "./components/plan/LegalHousePlanUnit";
import LitigationLayout from "./components/plan/LitigationLayout";
import ButlerHttp from "./common/ButlerHttp";
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";
import CourtList from "./components/litigation/court/CourtList";
import LitigationCaseLayout from "./components/litigation/LitigationCaseLayout";
import CaseDocumentsManager from "./components/CaseDocumentsManager";

export default {
  name: "Litigation",
  components: {
    LitigationCaseLayout,
    CourtList,
    SelectCdjProjectHeader,
    LitigationLayout,
    LegalHousePlanUnit,
    RecordFilingStatusStatisticsTable,
    AgingType, LitigationStatisticsMonth, LitigationStatisticsDay, LitigationListLayout,
    CaseDocumentsManager
  },
  provide(){
    return{
      where:this.where,
      reginWhere:this.reginWhere
    }
  },
  data() {
    return {
      is_loading: false,
      where: {
        text:"",
        type:"",
        type_ex:"",
        start_time:moment(new Date()).format("YYYY-MM-01"),
        end_time:moment(new Date()).format("YYYY-MM-DD"),
        time_field:"send_time",
      },

      type_list:[],
      project_region_list:[],
      reginWhere:{
        type_id:"",
        type_list:[],
        project_region:"",
        project_region_list:[],
        project_name:"",
        project_list:[],
        group_by:"",
        area_id:"",
        area_list:[],
        project_ids:[],
        age:"",
        level:0
      },
      time_field_list:[
        {name:"记录添加时间",value:"created_at"},
        {name:"实际催费时间",value:"send_time"},
      ],
      card_index:"LitigationLayout"
    }
  },
  mounted() {

  },
  activated() {
    const that=this;
    if(that.$route.query.card_index){
      that.card_index=that.$route.query.card_index
    }
  },
  methods: {
    exportExcelNote(){
      const that = this;
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      ButlerHttp.post("Litigation/exportExcel", {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          window.open(__HTTP__.defaults.baseURL + res.data);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    onHeader(data){
      const that=this;
      that.reginWhere.type_id=data.type_id;
      that.reginWhere.type_list=data.type_list;
      that.reginWhere.project_region=data.project_region;
      that.reginWhere.project_region_list=data.project_region_list;
      that.reginWhere.project_region_level=data.project_region_level;
      that.reginWhere.project_name=data.project_name;
      that.reginWhere.project_list=data.project_list;
      that.reginWhere.group_by=data.group_by;
      that.reginWhere.area_id=data.area_id;
      that.reginWhere.area_list=data.area_list;
      that.reginWhere.project_ids=data.project_ids;
      that.reginWhere.level=data.level;
      that.is_loading=true;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "common";

.m-2{
  width: 150px;
}
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  margin: 20px 0 0 20px;
  width: calc( 100% - 10px );
  overflow-y: scroll;
  height: calc( 100vh - 150px );

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }

  >>>.el-tabs__item{
    color: black;
  }
}
.view-file-win{
  height: 60vh;
  overflow-y: scroll;
  .main-log{
    margin: 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/Litigation.vue